<template>
  <v-form v-model='valid' ref='form' lazy-validation>
    <v-container>
      <v-layout>
        <v-flex md6>
          <span class="subheading">Ingrese los datos del cargo que ocupa, ocupó, u ocupará</span>
        </v-flex>
        <v-flex md6>
          <v-layout align-center justify-end v-if='!modificar'>
            <v-btn fab color="primary" class="botonEdit" @click='modificarDatos(), obtenerDescripcionTipoFunciones()'>
              <v-icon>edit</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <v-layout wrap>
        <v-flex xs12 sm6 md6>
          <v-layout align-center>
            <card-tool-tip prepend-icon="help_outline" :icon-color="'primary'" v-if='modificar'>
              <template v-slot:contenido>
                <span><b>Ayuda y Asistencia</b></span><br>
                <v-divider color="primary" class="my-2"/>
                <span>NOMBRE COMPLETO DE LA ENTIDAD/EMPRESA PÚBLICA Señalar el nombre completo de la Entidad o Empresa Pública donde el declarante prestará, presta o prestó servicios y no así del ente tutor (sin siglas).</span>
              </template>
            </card-tool-tip>&nbsp;
            <v-text-field
              v-model='entidad'
              label='Nombre Completo de la Entidad/Empresa Pública (sin siglas)*'
              :rules='generalRules'
              required
              :disabled='!modificar'
              maxlength='200'
              @keyup="ciudadLocalidad = ciudadLocalidad ? ciudadLocalidad.replace(/['%#{}*]/g, ''):''"
            ></v-text-field>
          </v-layout>
                  </v-flex>
        <v-flex xs12 sm6 md6>
          <v-layout align-center>
            <card-tool-tip prepend-icon="help_outline" :icon-color="'primary'" v-if='modificar'>
              <template v-slot:contenido>
                <span><b>Ayuda y Asistencia</b></span><br>
                <v-divider color="primary" class="my-2"/>
                <span>DENOMINATIVO DEL CARGO Indicar el denominativo del cargo según el memorando, contrato o Resolución emitido por la Entidad/Empresa Pública.</span>
              </template>
            </card-tool-tip>&nbsp;
            <v-text-field
              v-model='cargo'
              :rules='generalRules'            
              label='Denominativo del Cargo*'
              required
              :disabled='!modificar'
              maxlength='100'
              @keyup="ciudadLocalidad = ciudadLocalidad ? ciudadLocalidad.replace(/['%#{}*]/g, ''):''"
            ></v-text-field>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <!-- <p>{{this.fechaIniDbFormat}}</p><b/> -->
        <v-flex  xs12 sm6 md6>
          <v-layout align-center>
            <card-tool-tip prepend-icon="help_outline" :icon-color="'primary'" v-if='modificar'>
              <template v-slot:contenido>
                <span><b>Ayuda y Asistencia</b></span><br>
                <v-divider color="primary" class="my-2"/>
                <span>FECHA DE INICIO Se deberá consignar la fecha precisa de inicio  del ejercicio del cargo que figura en el memorando, contrato o Resolución emitido por la Entidad/Empresa Pública.</span>
              </template>
            </card-tool-tip>&nbsp;
            <global-date-input-picker
              v-model="date" :hint="'Formato DD/MM/AAAA'" :disabled='!modificar' :rules="dateRules" label="Fecha Inicio del Cargo*">
            </global-date-input-picker>   
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-layout align-center>
            <card-tool-tip prepend-icon="help_outline" :icon-color="'primary'" v-if='modificar'>
              <template v-slot:contenido>
                <span><b>Ayuda y Asistencia</b></span><br>
                <v-divider color="primary" class="my-2"/>
                <span>FECHA DE FINALIZACIÓN Este campo debe ser llenado en caso de que el “Motivo de la Declaración” sea “Después del ejercicio del cargo”, debiendo señalar con exactitud la fecha de conclusión de su relación laboral.</span>
              </template>
            </card-tool-tip>&nbsp;
            <!-- <p>{{this.fechaFinDbFormat}}</p><b/> -->
            <global-date-input-picker
              v-model="dateF" :hint="'Formato DD/MM/AAAA'" :disabled='!modificar' :rules="dateRulesF" label='Fecha Fin del Cargo'>
            </global-date-input-picker>  
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm6 md6>
          <v-layout align-center>
            <card-tool-tip prepend-icon="help_outline" :icon-color="'primary'" v-if='modificar'>
              <template v-slot:contenido>
                <span><b>Ayuda y Asistencia</b></span><br>
                <v-divider color="primary" class="my-2"/>
                <span>TOTAL MENSUAL GANADO Señalar con precisión el monto del sueldo salario, remuneración, retribución o concepto aplicable, que mensualmente percibe el declarante sin descuentos y no así su haber básico ni líquido pagable. Digite el monto en Bs.</span>
              </template>
            </card-tool-tip>&nbsp;
            <v-currency-field
              v-model='totalMensualGanado'
              label='Total Mensual Ganado en Bs.*'
              :rules='numbersRules'
              required
              :disabled='!modificar'
            ></v-currency-field>              
          </v-layout>
        </v-flex>
        <v-flex  xs12 sm6 md6>
          <v-layout align-center>
            <card-tool-tip prepend-icon="help_outline" :icon-color="'primary'" width="900px" v-if='modificar'>
              <template v-slot:contenido>
                <span><b>Ayuda y Asistencia</b></span><br>
                <v-divider color="primary" class="my-2"/>
                  <span>TIPO DE CARGO</span><br>
                  <span>Ley 2027 LEY DEL ESTATUTO DEL FUNCIONARIO PÚBLICO ARTÍCULO 5° (CLASES DE SERVIDORES PÚBLICOS).</span><br>
                  <span>Los servidores públicos se clasifican en:</span><br>
                  <span>a) Funcionarios electos: Son aquellas personas cuya función pública se origina en un proceso eleccionario previsto por la Constitución Política del Estado. Estos funcionarios no están sujetos a las disposiciones relativas a la Carrera Administrativa y Régimen Laboral del Presente Estatuto.</span><br>
                  <span>b) Funcionarios designados: Son aquellas personas cuya función pública emerge de un nombramiento a cargo público, conforme a la Constitución Política del Estado, disposición legal u Sistema de Organización Administrativa aplicable. Estos funcionarios no están sujetos a las disposiciones relativas a la Carrera Administrativa del presente Estatuto.</span><br>
                  <span>c) Funcionarios de libre nombramiento: Son aquellas personas que realizan funciones administrativas de confianza y asesoramiento técnico especializado para los funcionarios electos o designados. El Sistema de Administración de Personal, en forma coordinada con los Sistemas de Organización Administrativa y de Presupuesto, determinará el número y atribuciones especificas de éstos y el presupuesto asignado para este fin. Estos funcionarios no están sujetos a las disposiciones relativas a la Carrera Administrativa del presente Estatuto.</span><br>
                  <span>d) Funcionarios de carrera: Son aquellos que forman parte de la administración pública, cuya incorporación y permanencia se ajusta a las disposiciones de la Carrera Administrativa que se establecen en el presente Estatuto.</span><br>
                  <span>e) Funcionarios interinos: Son aquellos que, de manera provisional y por un plazo máximo e improrrogable de 90 días, ocupan cargos públicos previstos para la carrera administrativa, en tanto no sea posible su desempeño por funcionarios de carrera conforme al presente Estatuto y disposiciones reglamentarias.</span><br>
                  <span>En caso de no corresponder a ninguna de las definiciones se marcará la casilla “Otro”.</span>
              </template>
            </card-tool-tip>&nbsp;
            <v-autocomplete
            :no-data-text="$t('comun.sin_resultados_busqueda')"
              v-model='tipoCargo'
              :items='itemsCargo'
              item-text='tipcar_descripcion'
              item-value='tipcar_codigo'
              label='Tipo de Cargo*'
              :rules='dRules'
              required
              :disabled='!modificar'
              clearable
            ></v-autocomplete>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm6 md6>
          <v-autocomplete
          :no-data-text="$t('comun.sin_resultados_busqueda')"
            v-model='tipoFuncion'
            :items='itemsFunciones'
            item-text='tipfun_descripcion'
            item-value='tipfun_codigo'
            label='Función que Cumple*'
            @change='obtenerDescripcionTipoFunciones()'
            :rules='dRules'
            required
            :disabled='!modificar'
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md6>
          <div class="decretosBoton">
          <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-show='modificar' v-on="on" small tile outline color="primary">
           <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
          </v-btn>
      </template>
      <v-card class="px-2 py-1">
        <v-card-text class="black--text body-2">
          <v-icon small color="info">info</v-icon>&nbsp;
          <span>{{this.tipoFuncionDetalle}}</span>
        </v-card-text>
      </v-card>
    </v-menu>
        </div>
        </v-flex>
        <v-flex xs12 md6  v-show='modificar' class="decretos">
          <v-alert align='justify' :value='!!this.tipoFuncionDetalle' type='info' outline>{{this.tipoFuncionDetalle}}</v-alert>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <span class="subheading">Ubicación Geográfica del Cargo</span>
        </v-flex>
      </v-layout>
      <v-layout wrap v-show="!this.habilitarNacionalExtrangero">
        <v-flex xs12 sm4 md4>
          <v-autocomplete
            @change='cargarProvincias(), limpiarDefecto()'
            v-model='departamento'
            :items='itemsDepartamento'
            item-text='dep_descripcion'
            item-value='dep_codigo'
            label='Departamento*'
            :no-data-text="$t('comun.sin_resultados_busqueda')"
            :rules='dRules'
            required
            :disabled='!modificar'
            persistent-hint
            return-object
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-autocomplete
            @change='cargarLocalidades()'
            v-model='provincia'
            :items='itemsProvincia'
            item-text='pro_descripcion'
            item-value='pro_codigo'
            label='Provincia*'
            :rules='dRules'
            required
            :disabled='!modificar'
            :no-data-text="$t('comun.sin_resultados_busqueda')"
            persistent-hint
            return-object
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex  xs12 sm4 md4>
          <v-autocomplete
            v-model='localidad'
            :items='itemsLocalidad'
            item-text='loc_descripcion'
            item-value='loc_codigo'
            label='Localidad*'
            :rules='dRules'
            required
            :disabled='!modificar'
            :no-data-text="$t('comun.sin_resultados_busqueda')"
            persistent-hint
            return-object
            clearable
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex  xs12 sm12 md12 v-show="this.habilitarNacionalExtrangero">  
          <v-text-field
            v-model='ciudadLocalidad'
            label='Dirección del Lugar de Trabajo*'
            :disabled='!modificar'
            maxlength='100'
            @keyup="ciudadLocalidad = ciudadLocalidad ? ciudadLocalidad.replace(/['%{}*]/g, ''):''"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12>
          <div
            class='v-label theme--light error--text'
            v-show='codErrorExtrangero !== null'
          >{{this.msgExtrangero}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm12 md12>
          <v-tooltip color="secondary" top>
            <template v-slot:activator='{ on }'>
          <v-textarea
            @change="observaciones = $util.sanitiza(observaciones)"
            v-model='observaciones'
            label='Observaciones'
            :disabled='!modificar'
            maxlength='250'
            :counter='250'
            v-on='on'
            hint='Máximo 250 caracteres.'
            persistent-hint
            :rules="$validate(['text_area'])"
            rows="1"
            auto-grow
          ></v-textarea>
          </template>
            <span>Detallar cualquier aclaración que el declarante considere pertinente, respecto a los datos del cargo. 
</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <br>
      <v-layout wrap>
        <v-flex sm12 md12>
          <v-subheader><p class='plomo--text'>Por favor llene los campos requeridos*</p></v-subheader>
        </v-flex>
      </v-layout>
      <v-btn
        color='primary'
        @click='modificarDatos(), obtenerDescripcionTipoFunciones()'
        v-show='!modificar'
      >
        <v-icon>create</v-icon>&nbsp;Modificar
      </v-btn>
      <v-btn :loading='loadingButton' color='primary' @click='guardaDatosCargoOcupa' v-show='modificar'>
        <v-icon>save</v-icon>&nbsp;Guardar
      </v-btn>
      <v-btn color='error' v-show='modificar' @click='cancelarAction'>
        <v-icon>cancel</v-icon>&nbsp;Cancelar
      </v-btn>
    </v-container>
  </v-form>
</template>
<script>
import validate from '@/common/mixins/validate';
import Parametricas from '../djbrd/mixins/parametricas';
export default {
  mixins: [ Parametricas, validate ],
  mounted () {
    this.$root.$on('clickedDatosDeclaracion', () => {
      this.$service.get(`djbr_registro/declaracion_jurada`, {}).then(response => {
        if (response) {
          this.nacionalExtrangero = response.datcom_nacional_extranjero;
          this.habilitarNacionalExtrangero = response.datcom_nacional_extranjero === 2;
        }
      });
    });
    this.$root.$on('clickedGuardarDatosCargoOcupara', () => {
      this.guardaDatosCargoOcupa();
    });
  },
  created () {
    this.obtieneDatos();
    if (this.items_entidades.length === 0) {
      this.obtenerEntidadesParametrica().then(respuesta => {
        this.items_entidades = respuesta.datos;
      });
    }
    if (this.itemsCargo.length === 0) {
      this.obtenerTipoCargoParametrica().then(respuesta => {
        this.itemsCargo = respuesta.datos;
      });
    }
    if (this.itemsFunciones.length === 0) {
      this.obtenerTipoFuncionesParametrica().then(respuesta => {
        this.itemsFunciones = respuesta.datos;
        this.obtenerDescripcionTipoFunciones();
      });
    }
    if (this.itemsDepartamento.length === 0) {
      this.obtenerDepartamentosParametrica().then(respuesta => {
        this.itemsDepartamento = respuesta.datos;
        this.cargarProvincias();
      });
    }
    this.$service.get(`djbr_registro/declaracion_jurada`, {}).then(response => {
      if (response) {
        this.nacionalExtrangero = response.datcom_nacional_extranjero;
        this.habilitarNacionalExtrangero = response.datcom_nacional_extranjero === 2;
      }
    });
    // Formateo de fecha actual
    const [year, month, day] = this.fechaActual.split('-');
    this.fechaActual = `${day}/${month}/${year}`;
  },
  data: () => ({
    loadingButton: false,
    entidad: '',
    cargo: '',
    fechaIni: null,
    date: '',
    dateF: '',
    fechaActual: new Date().toISOString().substr(0, 10),
    menu: false,
    menu1: false,
    totalMensualGanado: 0,
    tipoCargo: '',
    tipoFuncion: '',
    tipoFuncionDetalle: '',
    departamento: { dep_codigo: '-1', dep_descripcion: '' },
    provincia: { pro_codigo: '-1', pro_descripcion: '' },
    localidad: { loc_codigo: '-1', loc_descripcion: '' },
    ciudadLocalidad: null,
    declararComo: null,
    nacionalExtrangero: null,
    habilitarNacionalExtrangero: false,
    codErrorNacional: null,
    codErrorExtrangero: null,
    msgExtrangero: null,
    observaciones: '',
    codTipoServidorPublico: null,
    registro: '',
    items_entidades: [],
    itemsCargo: [],
    itemsFunciones: [],
    itemsDepartamento: [],
    itemsProvincia: [],
    itemsLocalidad: [],
    modificar: false,
    valid: false,
    dRules: [v => !!v || 'Este campo es requerido'],
    generalRules: [v => !!v || 'Este campo es requerido',
      v => /^[a-zA-Z0-9-_/.*(),.;:=#°ñÑÁáÉéÍíóÓúÚüÜ \r\n]+$/.test(v) || 'Carácter especial no permitido'],
    numbersRules: [v => !!v || 'Este campo es requerido y debe ser un monto en Bolivianos',
      v => v.length < 11 || 'El valor solo puede tener máximo 8 números'],
    dateRules: [v => !!v || 'Este campo es requerido',
      v => (v && v.length <= 10) || 'El formato requerido DD/MM/AAAA sólo tiene 10 campos',
      v => (v && /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](18|19|20|21|22|23)\d\d$/.test(v)) || 'Fecha no válida'],
    dateRulesF: [v => (v === '' || v === null ? true : /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](18|19|20|21|22|23)\d\d$/.test(v)) || `Fecha no válida`],
    // dateRulesF: [v => ((v || '').length <= 10) || 'El formato requerido DD/MM/AAAA sólo tiene 10 campos'],
    currency_config: {
      thousands: '.',
      decimal: ',',
      suffix: '',
      prefix: 'Bs.',
      precision: 0,
      masked: false,
      allowBlank: true
    }
  }),
  methods: {
    cargarProvincias () {
      if (this.departamento.dep_codigo !== '-1' && this.departamento.dep_codigo !== -1) {
        this.$service
          .get(`provincias/departamentos/${this.departamento.dep_codigo}`, {})
          .then(response => {
            if (response) {
              this.itemsProvincia = response;
            }
          });
      }
    },
    cargarLocalidades () {
      if (this.departamento.dep_codigo !== '-1' && this.departamento.dep_codigo !== -1) {
        let provinciaCodigo = this.provincia.pro_codigo || this.provincia.prov_codigo;
        this.$service
          .get(
            `localidades/${provinciaCodigo}/${this.departamento.dep_codigo}`,
            {}
          )
          .then(response => {
            if (response) {
              this.itemsLocalidad = response;
            }
          });
      }
    },
    setearDatos (response) {
      this.entidad = response.cardec_descripcion_entidad;
      this.cargo = response.cardec_descripcion_cargo;
      this.date = this.$util.formatDateDDMMYYYY(response.cardec_fecha_desde);
      this.dateF = response.cardec_fecha_hasta === '1900-01-01' ? null : this.$util.formatDateDDMMYYYY(response.cardec_fecha_hasta);
      this.totalMensualGanado = response.cardec_haber_basico.replace('.00', '');
      this.tipoCargo = response.tipcar_codigo;
      this.tipoFuncion = response.tipfun_codigo;
      this.departamento = {
        dep_codigo: response.dep_codigo,
        dep_descripcion: response.dep_descripcion
      };
      this.provincia = {
        pro_codigo: response.prov_codigo,
        pro_descripcion: response.pro_descripcion
      };
      this.localidad = {
        loc_codigo: response.loc_codigo,
        loc_descripcion: response.loc_descripcion
      };
      this.observaciones = response.cardec_observacion;
      this.ciudadLocalidad = response.cardec_descripcion_lugar;
      this.cargarProvincias();
      this.cargarLocalidades();
    },
    obtieneDatos () {
      this.$service.get(`djbr_registro/cargo_a_ocupar/`).then(response => {
        if (response) {
          this.mensajeValidacion = response.err_existente;
          if (response.cardec_codigo === -1) {
            this.modificar = true;
            this.registro = 'Registro';
            // let ctrl = this.$storage.get('ctrl');
            // ctrl.datos_generales.cargo_ocupara = true;
            // this.$storage.set('ctrl', ctrl);
          } else {
            this.registro = 'Actualizacion';
            this.datosCargo = response;
            this.reinicializar();
            this.setearDatos(response);
            this.$storage.set('codigoCargo', response.cardec_codigo);
          }
        }
      });
    },
    guardaDatosCargoOcupa () {
      if (this.$refs.form.validate()) {
        this.loadingButton = true;
        // Validacion de fechas inicio y fin de cargo
        let f = this.$storage.get('user').fecha_nacimiento.split('/');
        let fnac = Date.parse(`${f[2]}-${f[1]}-${f[0]}`);
        let bornYear = new Date(`${f[2]}-${f[1]}-${f[0]}`).getFullYear();
        let date = this.$util.formatDateYYYYMMDD(this.date);
        let dateF = this.$util.formatDateYYYYMMDD(this.dateF);
        let dateFYear = new Date(dateF).getFullYear();
        if (Date.parse(dateF) > 0 && Date.parse(date) >= Date.parse(dateF)) {
          this.$message['warning']('Por Favor revise las fecha fin del cargo, la fecha fin de cargo no puede ser menor o igual a la fecha inicio del cargo.');
          this.loadingButton = false;
        } else if (Date.parse(date) < fnac) {
          this.$message['warning']('Por Favor revise la fecha desde, no es válida.');
          this.loadingButton = false;
        } else if (parseInt(dateFYear) > (parseInt(bornYear) + 100)) {
          this.$message['warning']('Por Favor revise la fecha hasta, no es válida.');
          this.loadingButton = false;
        } else {
          if (this.registro === 'Registro') {
            this.RegistraDatosCargoOcupa();
          }
          if (this.registro === 'Actualizacion') {
            this.ActualizarDatosCargoOcupa();
          }
          let ctrl = this.$storage.get('ctrl');
          ctrl.datos_generales.cargo_ocupara = false;
          this.$storage.set('ctrl', ctrl);
        }
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos.');
      }
    },
    ActualizarDatosCargoOcupa () {
      if (this.totalMensualGanado === 0) {
        this.$message['warning']('Debe ingresar un monto valido mayor a cero');
        this.loadingButton = false;
        return;
      }
      if (this.nacionalExtrangero === 1) {
        //  Servidor Publico
        this.codErrorNacional = null;
        if (this.departamento.dep_codigo === -1 || this.provincia.pro_codigo === -1 || this.localidad.loc_codigo === -1) {
          this.codErrorNacional = 0;
          this.$message['warning']('Debe ingresar el Departamento, Provincia y Localidad');
          this.loadingButton = false;
          return;
        }
        this.datoCiudadLocalidad = this.localidad.loc_descripcion;
      }
      if (this.nacionalExtrangero === 2) {
        // Servidor Publico en el Exterior
        this.codErrorExtrangero = null;
        if (this.ciudadLocalidad === null || this.ciudadLocalidad === '') {
          this.codErrorExtrangero = 0;
          this.$message['warning']('Debe ingresar la dirección del lugar de trabajo');
          this.loadingButton = false;
          return;
        }
        this.datoCiudadLocalidad = this.ciudadLocalidad;
      }
      if (this.codErrorNacional === null && this.codErrorExtrangero === null) {
              // La fecha fin de cargo es null
        if (this.dateF === '') {
          this.dateF = '1900-01-01';
        }
        let params = {
          cod_cargo: this.datosCargo.cardec_codigo,
          cod_departamento: this.departamento.dep_codigo,
          cod_provincia: this.provincia.pro_codigo,
          cod_localidad: this.localidad.loc_codigo,
          cod_tipo_cargo: this.tipoCargo,
          cod_funcion_cumple: this.tipoFuncion,
          ciudad_localidad: this.datoCiudadLocalidad, // this.localidad.loc_descripcion,
          codigo_entidad: 0,
          denom_entidad: this.entidad,
          denom_cargo: this.cargo,
          fecha_inicio: this.date,
          fecha_fin: this.dateF,
          haber_basico: this.totalMensualGanado,
          cod_pais: this.$storage.get('codigoPais'), // this.datosCargo.pai_codigo,    // Valor recuperado del storage
          observacion: this.observaciones
        };
        this.$service
          .put(`djbr_registro/cargo_a_ocupar`, params)
          .then(response => {
            if (response) {
              if (response.err_existente === 1) {
                this.$message['warning'](response.err_mensaje);
                this.loadingButton = false;
              }
              this.cod_error = response.err_codigo;
              this.msg_error = response.err_mensaje;
              if (this.cod_error === 0) {
                this.status_error = 'success';
                this.cancelarAction();
                this.$message['success'](response.err_mensaje);
                this.loadingButton = false;
              } else {
                this.status_error = 'error';
                this.loadingButton = false;
              }
            } else {
              this.loadingButton = false;
            }
          })
          .catch(e => {
            console.log(e);
            this.loadingButton = false;
          });
      } else {
        this.$message['warning']('Por favor revise los datos que ha ingresado.');
        this.loadingButton = false;
      }
    },
    RegistraDatosCargoOcupa () {
      if (this.totalMensualGanado === 0) {
        this.$message['warning']('Debe ingresar un monto valido mayor a cero');
        this.loadingButton = false;
      }
      if (this.nacionalExtrangero === 1) {
        //  Servidor Publico
        this.codErrorNacional = null;
        if (this.departamento.dep_codigo === -1 || this.provincia.pro_codigo === -1 || this.localidad.loc_codigo === -1) {
          this.codErrorNacional = 0;
          this.$message['warning']('Debe ingresar el Departamento, Provincia y Localidad');
          this.loadingButton = false;
        }
        this.datoCiudadLocalidad = this.localidad.loc_descripcion;
      } else if (this.nacionalExtrangero === 2) {
        // Servidor Publico en el Exterior
        this.codErrorExtrangero = null;
        if (this.ciudadLocalidad === null || this.ciudadLocalidad === '') {
          this.codErrorExtrangero = 0;
          this.$message['warning']('Debe ingresar la dirección del lugar de trabajo');
          this.loadingButton = false;
        }
        this.datoCiudadLocalidad = this.ciudadLocalidad;
      }
      if (this.codErrorNacional === null && this.codErrorExtrangero === null) {
        // La fecha fin de cargo es null
        if (this.dateF === '') {
          this.dateF = '1900-01-01';
        }
        let params = {
          cod_departamento: this.departamento.dep_codigo,
          cod_provincia: this.provincia.pro_codigo,
          cod_localidad: this.localidad.loc_codigo,
          cod_tipo_cargo: this.tipoCargo,
          cod_funcion_cumple: this.tipoFuncion,
          ciudad_localidad: this.datoCiudadLocalidad, // this.localidad.loc_descripcion,
          codigo_entidad: 0,
          denom_entidad: this.entidad,
          denom_cargo: this.cargo,
          fecha_inicio: this.date,
          fecha_fin: this.dateF,
          haber_basico: this.totalMensualGanado,
          cod_pais: this.$storage.get('codigoPais'), // Valor recuperado del storage
          observacion: this.observaciones
        };
        this.$service
          .post(`djbr_registro/cargo_a_ocupar`, params)
          .then(response => {
            if (response) {
              if (response.err_existente === 1) {
                this.$message['warning'](response.err_mensaje);
                this.loadingButton = false;
              }
              this.cod_error = response.err_codigo;
              this.msg_error = response.err_mensaje;
              if (this.cod_error === 0) {
                this.status_error = 'success';
                this.$storage.set('codigoCargo', response.inf_codigo);
                this.cancelarAction();
                this.obtieneDatos();
                this.$message['success'](response.err_mensaje);
                this.loadingButton = false;
              } else {
                this.status_error = 'error';
                this.loadingButton = false;
              }
            } else {
              this.loadingButton = false;
            }
          })
          .catch(e => {
            console.log(e);
            this.loadingButton = false;
          });
      } else {
        this.$message['warning']('Por favor revise los datos que ha ingresado.');
        this.loadingButton = false;
      }
    },
    cancelarAction () {
      this.cod_error = null;
      this.modificar = !this.modificar;
      this.obtieneDatos();
      let ctrl = this.$storage.get('ctrl');
      ctrl.datos_generales.cargo_ocupara = false;
      this.$storage.set('ctrl', ctrl);
      this.$refs.form.resetValidation();
    },
    obtenerDescripcionTipoFunciones () {
      this.itemsFunciones.forEach(element => {
        if (this.tipoFuncion === element.tipfun_codigo) {
          this.tipoFuncionDetalle = element.tipfun_detalle;
        }
      });
    },
    reinicializar () {
      this.entidad = '';
      this.cargo = '';
      this.date = '';
      this.dateF = '';
      this.totalMensualGanado = 0;
      this.tipoCargo = '';
      this.tipoFuncion = '';
      this.tipoFuncionDetalle = '';
      this.departamento = { dep_codigo: '0', dep_descripcion: '' };
      this.provincia = { pro_codigo: '0', pro_descripcion: '' };
      this.localidad = { loc_codigo: '0', loc_descripcion: '' };
      this.observaciones = '';
      this.codErrorNacional = null;
      this.codErrorExtrangero = null;
      this.msgExtrangero = null;
    },
    limpiarDefecto () {
      this.provincia = { pro_codigo: '-1', pro_descripcion: '' };
      this.localidad = { loc_codigo: '-1', loc_descripcion: '' };
    },
    modificarDatos () {
      this.modificar = !this.modificar;
      let ctrl = this.$storage.get('ctrl');
      ctrl.datos_generales.cargo_ocupara = true;
      this.$storage.set('ctrl', ctrl);
    }
  }
};
</script>
<style lang='scss'>
.contenido_estilo {
  width: 800px !important;
}
@media (max-width: 600px) {
  .contenido_estilo {
    width: 250px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/datosGenerales/cargoOcupara.vue